import { Component, Vue } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import AccountApi from '@web/services/AccountService';
import { FormFieldModel, FieldsModel, ModeModel } from '../../models/LoginModels';
import { EFieldNames } from '../../models/Enums/EFieldNames';
import { EModes } from '../../models/Enums/EModes';
import AppLoginLayout from './Layout.vue';

const api = new AccountApi();

@Component({
  components: {
    AppLoginLayout
  }
})
export default class LayoutAbstract extends Vue {
  @Validations()
  validations = {};

  public fields: FieldsModel = {};

  public model = {};

  public mode = EModes.Parents;

  public loading = false;

  public action = '';

  public serverError: string[] = [];

  public modesConfig: ModeModel[] = [
    {
      key: EModes.Parents,
      label: 'Parents and organizations'
    },
    {
      key: EModes.Students,
      label: 'Students'
    }
  ];

  get isParents(): boolean {
    return this.mode === EModes.Parents;
  }

  get isFormInvalid(): boolean {
    return this.$v.model.$dirty && this.$v.model.$invalid;
  }

  get errors(): { [errorName: string]: string } {
    return Object.fromEntries(
      Object.entries(this.fields).map(([field, { errors }]: [string, FormFieldModel]) => [
        field,
        Object.entries(errors).reduce((err, [key, text]: [string, string]) => {
          if (err) return err;

          const vField = this.$v.model[field];
          if (vField && !vField[key] && vField.$dirty) return text;

          return '';
        }, '')
      ])
    );
  }

  async validateEmail(email: string) {
    if (!email.trim().length) {
      return;
    }
    this.loading = true;
    try {
      const res = await api.checkEmail({ email });
      console.log(res);
      this.serverError = [];
    } catch (error) {
      console.log(error.response.data);
      this.serverError = ['There is already an account created with this e-mail'];
    } finally {
      this.loading = false;
    }
  }

  checkValidation(fields: EFieldNames[]) {
    return fields.every((field: string) => {
      const vField = this.$v.model[field];
      return vField && vField.$dirty && !vField.$invalid;
    });
  }
}
